<template>
    <div class="datepicker-row">
        <template v-for="(day, index) in week">
            <a
                v-if="selectableDate(day) && !disabled"
                :key="index"
                :class="[classObject(day), {'has-event':eventsDateMatch(day)}, indicators]"
                class="datepicker-cell"
                role="button"
                href="#"
                :disabled="disabled"
                @click.prevent="emitChosenDate(day)"
                @keydown.enter.prevent="emitChosenDate(day)"
                @keydown.space.prevent="emitChosenDate(day)">
                {{ day.getDate() }}

                <div class="events" v-if="eventsDateMatch(day)">
                    <div
                        class="event"
                        :class="event.type"
                        v-for="(event, index) in eventsDateMatch(day)"
                        :key="index"/>
                </div>

                <div class="parity" v-if="hasParity"></div>

            </a>
            <div
                v-else
                :key="index"
                :class="classObject(day)"
                class="datepicker-cell">
                {{ day.getDate() }}

                <div class="parity" v-if="hasParity"></div>
            </div>
        </template>
    </div>
</template>

<script>
import DatepickerTableRow from "buefy/src/components/datepicker/DatepickerTableRow";

export default {
  extends: DatepickerTableRow,
  props: {
    academicYearStart: {
      type: Date
    },
    firstDayOfWeek: Number
  },
  computed: {
    hasParity() {
      return this.academicYearStart != null;
    }
  },
  methods: {
    /*
    * Build classObject for cell using validations
    */
    classObject(day) {
      function dateMatch(dateOne, dateTwo) {
        // if either date is null or undefined, return false
        if (!dateOne || !dateTwo) {
          return false;
        }

        return (
          dateOne.getDate() === dateTwo.getDate() &&
          dateOne.getFullYear() === dateTwo.getFullYear() &&
          dateOne.getMonth() === dateTwo.getMonth()
        );
      }
      
      let diff = this.$moment(day)
        .weekday(this.firstDayOfWeek)
        .diff(
          this.$moment(this.academicYearStart)
            .weekday(this.firstDayOfWeek)
            .startOf("day"),
          "weeks"
        );

      let odd = diff % 2 == 0;

      return {
        "is-odd": odd,
        "is-even": !odd,
        "is-selected": dateMatch(day, this.selectedDate),
        "is-today": dateMatch(day, new Date()),
        "is-selectable": this.selectableDate(day) && !this.disabled,
        "is-unselectable": !this.selectableDate(day) || this.disabled
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/datepicker/DatepickerTableRow.vue